import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const transferProductsSchema: CollectionCreateSchema = {
  name: CollectionName.TransferProducts,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "item_description",
      type: "string",
      infix: true,
      sort: true,
    },
    {
      name: "net_weight",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "net_volume",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "eligibility_Countries",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "container_number",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "container_seals",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "NZHSC_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "productionBatch_ids",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "package_quantity",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "package_type",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "item_marks",
      type: "string[]",
      optional: true,
      infix: true,
    },
    {
      name: "transfer_id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "certificate_number",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "unofficial_commercial_ref",
      type: "string",
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "comments",
      type: "string",
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "sequence_number",
      type: "int32",
      optional: true,
      sort: true,
    },
    {
      name: "updated_at",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
      index: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
